import { render } from "./Testimonials1.vue?vue&type=template&id=78cb6310&scoped=true"
import script from "./Testimonials1.vue?vue&type=script&lang=js"
export * from "./Testimonials1.vue?vue&type=script&lang=js"

import "./Testimonials1.vue?vue&type=style&index=0&id=78cb6310&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-78cb6310"

export default script